if (!customElements.get('product-modal')) {
    class ProductModal extends HTMLElement {
        constructor () {
            super();
            this.mediaModal = document.getElementById(`ProductModal-${this.dataset.sectionId}`);
            this.mainSlider = null;
            this.thumbnailSlider = null;
            this.currentScale = 1;
            this.maxScale = 4;
            this.lastTap = 0;
            this.init();

            // Add listener for variant changes to detect when the user changes the variant
            document.addEventListener('variant:changed', (event) => {
                const { variant, featuredMediaId } = event.detail;

                this.handleVariantChange(featuredMediaId, variant?.id);
            });
        }

        getMediaIdFromElement (element) {
            let mediaId;
            const img = element.querySelector('img');

            if (img && img.dataset.mediaId) {
                mediaId = parseInt(img.dataset.mediaId);
            } else if (element.dataset.mediaId) {
                mediaId = parseInt(element.dataset.mediaId);
            } else {
                const closestMediaElement = element.closest('[data-media-id]');

                mediaId = closestMediaElement ? parseInt(closestMediaElement.dataset.mediaId) : null;
            }

            return mediaId;
        }

        filterVariantImages (variantId) {
        // Hide all variant gallery images
            const allVariantSlides = this.mediaModal.querySelectorAll('.variant-gallery-image');

            allVariantSlides.forEach((slide) => {
                slide.classList.add('variant-hidden');
            });

            // Show only the current variant's gallery images
            if (variantId) {
                const currentVariantSlides = this.mediaModal.querySelectorAll(`.variant-gallery-image[data-variant-id="${variantId}"]`);

                currentVariantSlides.forEach((slide) => {
                    slide.classList.remove('variant-hidden');
                });
            }

            if (this.mainSlider) {
                this.mainSlider.update();
            }
            if (this.thumbnailSlider) {
                this.thumbnailSlider.update();
            }
        }

        init () {
        // Skip initialization if this is within a quick-add modal
            if (this.closest('quick-add-modal') || this.closest('.quick-add-modal__content')) {
                return;
            }

            this.initializeSwiper();

            const currentVariantId = this.dataset.currentVariantId;

            if (currentVariantId) {
                this.filterVariantImages(currentVariantId);
            }

            const modalOpeners = document.querySelectorAll('.product__modal-opener--image');

            modalOpeners.forEach((opener) => {
                opener.addEventListener('click', (event) => {
                    event.preventDefault();
                    const mediaId = this.getMediaIdFromElement(opener);

                    if (mediaId) {
                    // Get all slides (both visible and hidden)
                        const allSlides = Array.from(this.mediaModal.querySelectorAll('.modal-main-slider .swiper-slide[data-media-id]'));
                        const targetIndex = allSlides.findIndex(
                            (slide) => {
                                const slideMediaId = parseInt(slide.dataset.mediaId);
                                const sectionMediaId = parseInt(slide.dataset.mediaId.replace(`${this.dataset.sectionId}-`, ''));

                                return slideMediaId === mediaId || sectionMediaId === mediaId;
                            },
                        );

                        this.openModal(targetIndex !== -1 ? targetIndex : 0);
                    } else {
                        this.openModal(0);
                    }
                });
            });

            const closeButton = this.mediaModal.querySelector('.product-media-modal__toggle');

            closeButton?.addEventListener('click', () => {
                this.closeModal();
            });

            this.mediaModal.addEventListener('click', (event) => {
                if (event.target === this.mediaModal) {
                    this.closeModal();
                }
            });

            document.addEventListener('keyup', (event) => {
                if (event.key === 'Escape') {
                    this.closeModal();
                }
            });

            const mainSliderEl = this.mediaModal.querySelector('.modal-main-slider');

            if (mainSliderEl) {
                mainSliderEl.addEventListener('touchstart', this.handleTouchStart.bind(this));
                mainSliderEl.addEventListener('touchmove', this.handleTouchMove.bind(this));
                mainSliderEl.addEventListener('touchend', this.handleTouchEnd.bind(this));
            }
        }

        handleVariantChange (featuredMediaId, variantId) {
            if (!featuredMediaId) {
                return;
            }

            // Filter images by variant
            this.filterVariantImages(variantId);

            if (!this.mainSlider || !this.thumbnailSlider) {
                this.reinitializeSwiper();
                setTimeout(() => {
                    if (this.mainSlider && this.thumbnailSlider) {
                        this.handleVariantChange(featuredMediaId, variantId);
                    }
                }, 100);
                return;
            }

            const mainSliderEl = this.mediaModal.querySelector('.modal-main-slider');

            if (mainSliderEl) {
                mainSliderEl.removeEventListener('touchstart', this.handleTouchStart);
                mainSliderEl.removeEventListener('touchmove', this.handleTouchMove);
                mainSliderEl.removeEventListener('touchend', this.handleTouchEnd);
            }

            const allSlides = Array.from(this.mediaModal.querySelectorAll('.modal-main-slider .swiper-slide[data-media-id]'));
            const targetIndex = allSlides.findIndex((slide) => {
                const slideMediaId = parseInt(slide.dataset.mediaId);
                const sectionMediaId = parseInt(slide.dataset.mediaId.replace(`${this.dataset.sectionId}-`, ''));

                return slideMediaId === featuredMediaId || sectionMediaId === featuredMediaId;
            });

            if (targetIndex !== -1) {
                this.resetZoom();

                this.mainSlider.update();
                this.thumbnailSlider.update();

                this.mainSlider.slideTo(targetIndex, 0);
                this.thumbnailSlider.slideTo(targetIndex, 0);
            }

            // Rebind modal opener events for new variant
            const modalOpeners = document.querySelectorAll('.product__modal-opener--image');

            modalOpeners.forEach((opener) => {
                const newOpener = opener.cloneNode(true);

                opener.parentNode.replaceChild(newOpener, opener);

                newOpener.addEventListener('click', (event) => {
                    event.preventDefault();
                    const mediaId = this.getMediaIdFromElement(newOpener);

                    if (mediaId) {
                        const allSlides = Array.from(this.mediaModal.querySelectorAll('.modal-main-slider .swiper-slide[data-media-id]'));
                        const targetIndex = allSlides.findIndex(
                            (slide) => {
                                const slideMediaId = parseInt(slide.dataset.mediaId);
                                const sectionMediaId = parseInt(slide.dataset.mediaId.replace(`${this.dataset.sectionId}-`, ''));

                                return slideMediaId === mediaId || sectionMediaId === mediaId;
                            },
                        );

                        this.openModal(targetIndex !== -1 ? targetIndex : 0);
                    } else {
                        this.openModal(0);
                    }
                });
            });

            if (mainSliderEl) {
                mainSliderEl.addEventListener('touchstart', this.handleTouchStart.bind(this));
                mainSliderEl.addEventListener('touchmove', this.handleTouchMove.bind(this));
                mainSliderEl.addEventListener('touchend', this.handleTouchEnd.bind(this));
            }

            this.currentScale = 1;
            this.isDragging = false;
            this.lastTap = 0;
        }

        initializeSwiper () {
            const thumbSliderEl = this.mediaModal.querySelector('.modal-thumb-slider');
            const mainSliderEl = this.mediaModal.querySelector('.modal-main-slider');

            this.thumbnailSlider = new Swiper(thumbSliderEl, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 10,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });

            this.mainSlider = new Swiper(mainSliderEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                thumbs: {
                    swiper: this.thumbnailSlider,
                },
                on: {
                    slideChange: () => {
                        this.resetZoom();
                    },
                },
            });
        }

        async openModal (selectedIndex = 0) {
            this.mainSlider?.slideTo(selectedIndex, 0, false);
            this.thumbnailSlider?.slideTo(selectedIndex, 0, false);

            this.mainSlider?.update();
            this.thumbnailSlider?.update();

            document.body.classList.add('overflow-hidden');

            await new Promise((resolve) => setTimeout(resolve, 50));

            requestAnimationFrame(() => {
                this.mediaModal.classList.add('active');
            });
        }

        closeModal () {
            this.mediaModal.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
        }

        handleTouchStart (event) {
            if (event.touches.length === 2) {
                this.initialPinchDistance = Math.hypot(
                    event.touches[0].pageX - event.touches[1].pageX,
                    event.touches[0].pageY - event.touches[1].pageY,
                );
                this.startScale = this.currentScale;
            } else if (event.touches.length === 1) {
                const currentTime = new Date().getTime();
                const tapLength = currentTime - this.lastTap;

                if (tapLength < 300 && tapLength > 0) {
                    this.handleDoubleTap(event);
                    event.preventDefault();
                }
                this.lastTap = currentTime;

                if (this.currentScale > 1) {
                    const currentSlide = this.mainSlider.slides[this.mainSlider.activeIndex];
                    const image = currentSlide.querySelector('img');

                    this.isDragging = true;
                    this.startX = event.touches[0].clientX - (image.style.left ? parseInt(image.style.left) : 0);
                    this.startY = event.touches[0].clientY - (image.style.top ? parseInt(image.style.top) : 0);
                }
            }
        }

        handleTouchMove (event) {
            if (event.touches.length === 2) {
                event.preventDefault();

                const currentPinchDistance = Math.hypot(
                    event.touches[0].pageX - event.touches[1].pageX,
                    event.touches[0].pageY - event.touches[1].pageY,
                );

                const scale = (currentPinchDistance / this.initialPinchDistance) * this.startScale;

                this.setScale(scale);
            } else if (event.touches.length === 1 && this.isDragging) {
                event.preventDefault();
                const currentSlide = this.mainSlider.slides[this.mainSlider.activeIndex];
                const image = currentSlide.querySelector('img');
                const rect = currentSlide.getBoundingClientRect();

                let left = event.touches[0].clientX - this.startX;
                let top = event.touches[0].clientY - this.startY;

                const maxX = (image.offsetWidth * this.currentScale - rect.width) / 2;
                const maxY = (image.offsetHeight * this.currentScale - rect.height) / 2;

                left = Math.min(maxX, Math.max(-maxX, left));
                top = Math.min(maxY, Math.max(-maxY, top));

                image.style.left = `${left}px`;
                image.style.top = `${top}px`;
            }
        }

        handleTouchEnd () {
            this.isDragging = false;
            if (this.currentScale <= 1) {
                this.resetZoom();
            }
        }

        handleDoubleTap (event) {
            if (this.currentScale > 1) {
                this.resetZoom();
            } else {
                const scale = 2.5;
                const currentSlide = this.mainSlider.slides[this.mainSlider.activeIndex];
                const image = currentSlide.querySelector('img');
                const rect = image.getBoundingClientRect();
                const x = (event.touches ? event.touches[0].clientX : event.clientX) - rect.left;
                const y = (event.touches ? event.touches[0].clientY : event.clientY) - rect.top;

                const originX = (x / rect.width) * 100;
                const originY = (y / rect.height) * 100;

                this.setScale(scale, `${originX}% ${originY}%`);
            }
        }

        setScale (scale, transformOrigin = 'center') {
            const currentSlide = this.mainSlider.slides[this.mainSlider.activeIndex];
            const image = currentSlide.querySelector('img');

            scale = Math.min(Math.max(1, scale), this.maxScale);
            this.currentScale = scale;

            image.style.transformOrigin = transformOrigin;
            image.style.transform = `scale(${scale})`;

            image.style.left = '0px';
            image.style.top = '0px';

            if (scale > 1) {
                currentSlide.classList.add('is-zoomed');
                this.mainSlider.allowTouchMove = false;
                this.mainSlider.params.touchRatio = 0;
            } else {
                currentSlide.classList.remove('is-zoomed');
                this.mainSlider.allowTouchMove = true;
                this.mainSlider.params.touchRatio = 1;
            }
        }

        resetZoom () {
            this.currentScale = 1;
            const currentSlide = this.mainSlider.slides[this.mainSlider.activeIndex];
            const image = currentSlide.querySelector('img');

            image.style.transformOrigin = 'center';
            image.style.transform = '';
            image.style.left = '';
            image.style.top = '';
            currentSlide.classList.remove('is-zoomed');
            this.mainSlider.allowTouchMove = true;
            this.mainSlider.params.touchRatio = 1;
        }

        reinitializeSwiper () {
            if (this.mainSlider) {
                try {
                    this.mainSlider.destroy(true, true);
                } catch (e) {
                    console.log('Error destroying main slider:', e);
                }
            }
            if (this.thumbnailSlider) {
                try {
                    this.thumbnailSlider.destroy(true, true);
                } catch (e) {
                    console.log('Error destroying thumbnail slider:', e);
                }
            }

            this.mainSlider = null;
            this.thumbnailSlider = null;

            setTimeout(() => {
                this.initializeSwiper();
                this.isInitialized = true;
            }, 0);
        }
    }

    customElements.define('product-modal', ProductModal);
}
